import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=4d3183ce&"
import script from "./SearchView.vue?vue&type=script&lang=ts&"
export * from "./SearchView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports